import React from 'react';

interface HtmlInfoSectionProps {
  content: string;
}

const HtmlInfoSection: React.FC<HtmlInfoSectionProps> = ({ content }) => {
  return (
    <div className="my-6">
      {content.split(/<h3>(.*?)<\/h3>/g).map((section, idx) => {
        if (idx % 2 === 1) {
          // Heading
          return (
            <h3
              key={`heading-${idx}`}
              className="font-semibold text-[16px] md:text-[18px] lg:text-[20px] mt-6 mb-2"
            >
              {section.trim()}
            </h3>
          );
        } else if (section.trim()) {
          // Content: split by lines starting with '- ' (hyphen followed by space)
          const items = section
            .split(/\n-/)
            .map(item => item.trim())
            .filter(item => item.length > 0);
          if (items.length > 0) {
            return (
              <ul
                key={`list-${idx}`}
                className="list-disc ml-6 mb-4 text-[#677083] text-[14px] md:text-base"
              >
                {items.map((item, i) => (
                  <li key={i} className="mb-2">
                    {item}
                  </li>
                ))}
              </ul>
            );
          }
        }
        return null;
      })}
    </div>
  );
};

export default HtmlInfoSection;
